<template>
    <div>
        <p class="label" :class="{'text--disabled': disabled}">{{ label }}</p>
        <MultiplePickerInput
                :value="value"
                @input="onInput"
                :items="items"
                :loading="loading"
                :disabled-check-all="true"
                v-bind="$attrs"
                :disabled="disabled"
        />
    </div>
</template>

<script>
  import MultiplePickerInput from '@/components/inputs/MultiplePickerInput.vue';
  import ObtainedSpecialityService from '@/services/obtained-speciality.service.js';

  export default {
    name: "ObtainedSpecialityMultiplePickerInput",
    components: {
      MultiplePickerInput,
    },
    props: {
      value: { type: Array, default: () => []},
      label: { type: String, default: 'Spécialité(s) étudié(s)'},
      diplomaIds: {type: Array, default: () => []},
      taskEdit: { type: Boolean, default: false }
    },
    data() {
      return {
        items: [],
        loading: false,
        timeoutHandler: null,
        disabled: true,
      }
    },
    methods: {
      loadListItem() {
        const _this = this;

        // if (this.loading) return;

        this.loading = true;

        ObtainedSpecialityService.getList(this.diplomaIds)
          .then(({data}) => {
            data.forEach((group) => {
              // Push split
              _this.items.push({ divider: true });

              // Push header
              if (group.name) {
                _this.items.push({header: group.name});
              }

              // Push items
              group.children.forEach((item) => {
                _this.items.push(
                  Object.assign({}, item)
                );
              });
            });

            if (_this.items.length) {
              _this.disabled = false;
            } else {
              _this.disabled = true;
            }
          })
          .finally(() => {
            this.loading = false;
          });
      },
      onInput(event) {
        this.$emit('input', event);
      }
    },
    watch: {
      diplomaIds: {
        immediate: true,
        handler(value) {
          const _this = this;
          this.items = [];

          //check task edit 
          if(!this.taskEdit){
            this.$emit('input', []);
          }else{
            this.$emit('resetTask', false);
          }          

          if (Array.isArray(value) && value.length > 0) {
            clearTimeout(this.timeoutHandler);
            this.timeoutHandler = setTimeout(() => {
              _this.loadListItem();
            }, 1000);
          }
        }
      }
    }
  }
</script>

<style scoped>

</style>
